import { render } from "./SendProposalModal.vue?vue&type=template&id=475ea769"
import script from "./SendProposalModal.vue?vue&type=script&lang=js"
export * from "./SendProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__